import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Popover from 'researcher/components/Popover';
import { price } from 'researcher/helpers/price';
import { T, useTranslate } from 'shared/helper/translate';
var PrepaymentAndCreditsWidget = function PrepaymentAndCreditsWidget(_ref) {
  var companyShortName = _ref.companyShortName,
    currency = _ref.currency,
    totalCreditBalance = _ref.totalCreditBalance;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "card widget-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body text-center"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-money"
  }), "\xA0", /*#__PURE__*/React.createElement(T, {
    source: "Prepay and Credits"
  }), /*#__PURE__*/React.createElement(Popover, {
    content: "Bank Tooltip",
    params: companyShortName
  }, "\xA0", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-circle-question"
  }))), /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(T, {
    source: "total-credit-balance"
  })), /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, /*#__PURE__*/React.createElement("big", null, price(currency, totalCreditBalance), " ", currency.shortName)), /*#__PURE__*/React.createElement("a", {
    "aria-label": t('Make a Prepayment'),
    className: "btn btn-primary",
    href: "/researcher/prepay"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Make a Prepayment"
  }))));
};
export default PrepaymentAndCreditsWidget;